export default "Bliv lidt klogere på følelser og ansigtsudtryk – tegn et ansigtsudtryk og lav et flot og vildt hår af blade!";